import { useCallback, useState } from 'react';
import RecordTypeService from 'views/RecordType/service';

export const useSelectedRecordType = (selectedRecordType) => {
  const [recordType, setRecordType] = useState({});

  const fetchRecordType = useCallback(async () => {
    if (!selectedRecordType) {
      setRecordType({});
      return;
    }

    try {
      const response = await RecordTypeService.get(selectedRecordType);
      setRecordType(response.data.content);
    } catch (error) {
      console.error(error);
      setRecordType({});
    }
  }, [selectedRecordType]);

  return {
    recordType,
    fetchRecordType
  };
};
